// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateUruguayanStreetNumber(streetNumber: string): ?UserInputValidationError {
  return streetNumber && streetNumber.trim() && parseInt(streetNumber, 10) ? VALID : { id: 'empty'};
}
